import { Component, inject, OnInit, ViewChild } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { TitleBarComponent } from 'src/app/base/shared/title-bar/title-bar.component';
import { VendorScoreCardVendorsDataService } from './vendor-score-card-vendors-data.service';
import { ActivatedRoute } from '@angular/router';
import { SpinnerService } from 'src/app/base/spinner/spinner.service';
import { CheckBoxModule } from '@syncfusion/ej2-angular-buttons';
import { EditService, FilterService, GridModule, PageService, RowDataBoundEventArgs, SortService, ToolbarService } from '@syncfusion/ej2-angular-grids';
import { ToolbarModule } from '@syncfusion/ej2-angular-navigations';
import { DataManager } from '@syncfusion/ej2-data';
import { FilterDTO, FilterOperator, VendorScoreCardRowType, VendorScoreCardRowTypeV20 } from 'src/app/base/models/models.swagger.generated';
import {  DropDownListModule } from '@syncfusion/ej2-angular-dropdowns';
import { AvpCustomAdaptor } from 'src/app/base/shared/syncfusion/avp-custom-adaptor';
import { DialogComponent, DialogModule } from '@syncfusion/ej2-angular-popups';
import { VendorScoreCardFactsName, VendorScoreCardPointsName, VendorScoreCardRowTypeV20Name, VendorScoreCardTotalPointsCategoryName, VendorScoreCardUtil, VendorScoreCardWeightedPointsName } from '../../vendor-score-card-util';
import { GridBaseComponent } from 'src/app/base/shared/grid-base/grid-base.component';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
    selector: 'app-vendor-score-card-vendors',
    templateUrl: './vendor-score-card-vendors-data.component.html',
    styleUrls: ['./vendor-score-card-vendors-data.component.scss'],
    imports: [TitleBarComponent, TranslateModule, GridModule, CheckBoxModule,
        ToolbarModule, TitleBarComponent, DialogModule, DropDownListModule],
    providers: [PageService, FilterService, ToolbarService, SortService, EditService]
})

export class VendorScoreCardVendorsDataComponent extends GridBaseComponent<any> implements OnInit {
  @ViewChild('dialog') dialog: DialogComponent | any;

  protected override initializeEditForm(data: any): void {
    throw new Error('Method not implemented.');
  }
  protected override getEditDialogTitleParams(rowData: any): object {
    throw new Error('Method not implemented.');
  }

  public customEditSettings = {
    allowEditing: false,
    allowAdding: false,
    allowDeleting: false,
    mode: 'Dialog',
    showDeleteConfirmDialog: true
  };

  public vendorScoreCardName: string;
  public vendorScoreCardTotalPoints: string;

  public columnRowType: string = VendorScoreCardRowTypeV20Name;
  public columnPoints: string = VendorScoreCardPointsName;
  public columnFacts: string = VendorScoreCardFactsName;
  public columnWeightedPoints: string = VendorScoreCardWeightedPointsName;
  public columnTotalPointsCategory: string = VendorScoreCardTotalPointsCategoryName;

  private route = inject(ActivatedRoute);
  private translationBase = "i18n.shared.vendor-score-card-row-types.";
  private vendorScoreCardId: string;

  constructor(
    private vendorScoreCardVendorsDataService: VendorScoreCardVendorsDataService,
    translateService: TranslateService,
    private spinnerService: SpinnerService,
    private sanitizer: DomSanitizer
  ) {
    super(translateService, vendorScoreCardVendorsDataService);
  }

  ngOnInit() {
    this.route.paramMap.subscribe((params) => {
      this.vendorScoreCardId = params.get('id')!;
    });

    var filter: FilterDTO[] = [];
    filter[0] = new FilterDTO({
      field: "VendorScoreCardId",
      operator: FilterOperator.Equal,
      value: this.vendorScoreCardId
    })

    this.data = new DataManager({
      adaptor: new AvpCustomAdaptor(this.vendorScoreCardVendorsDataService, this.spinnerService, true, filter),
    });

    this.isActiveColumnName = 'active';
  }

  public getRowTypeTranslationString(rowType: VendorScoreCardRowTypeV20): string {
    return this.translationBase + VendorScoreCardRowTypeV20[rowType].toString();
  }

  public getRowTypeHtml(rowType: VendorScoreCardRowTypeV20): SafeHtml {
    const html = this.translateService.instant(this.getRowTypeTranslationString(rowType));
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }

  public displayData(data: string, rowType: VendorScoreCardRowTypeV20, columnType: string): string | null {
    return VendorScoreCardUtil.displayData(data, rowType, columnType, false);
  }

  public onDataBound(args: any) {
    this.vendorScoreCardName = this.vendorScoreCardVendorsDataService.getVendorName();
    this.vendorScoreCardTotalPoints = parseFloat(this.vendorScoreCardVendorsDataService.getTotalPoints()?.toString()).toFixed(2);
  }

  public onRowDataBound(args: RowDataBoundEventArgs) {
    VendorScoreCardUtil.addRowClasses(args);
  }
}
